import React, {PureComponent} from 'react';
import Panel from './Panel';
import Table from './Table';
import {Progress} from 'reactstrap';
import * as environment from '../modules/environment';
import * as TextManager from "../modules/languages/TextManager";


/*const Brasil = process.env.PUBLIC_URL + '/img/flags/Brasil.svg';
const Argentina = process.env.PUBLIC_URL + '/img/flags/Argentina.svg';
const Gabon = process.env.PUBLIC_URL + '/img/flags/Gabon.svg';
const Ireland = process.env.PUBLIC_URL + '/img/flags/Ireland.svg';
const Italia = process.env.PUBLIC_URL + '/img/flags/Italia.svg';
const Sierra = process.env.PUBLIC_URL + '/img/flags/Sierra.svg';


const israel = process.env.PUBLIC_URL + '/img/flags/il.svg';*/

export default class ProvidersTotal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            countriesConversion: this.loadCountriesConversion(),
            //countriesISO3: this.loadCountries()
            countriesISO2: this.loadCountries()
        };
    }

    loadCountriesConversion() {
        //return require('../modules/iso_conversion');
    }

    loadCountries() {
        //return require('../modules/countries_en_iso2');
    }

    findCountryNameByISO3 = (iso) => {
        let res = "";
        let obj = this.state.countriesISO3.find(e => e.value === iso);
        if (obj !== undefined) {
            res = obj.label;
        }
        return res;
    };

    findCountryNameByISO2 = (iso) => {
        let res = "";
        let obj = this.state.countriesISO2.find(e => e.value === iso);
        if (obj !== undefined) {
            res = obj.label;
        }
        return res;
    };

    findISO2fromISO3 = (iso3) => {
        let res = "";
        let obj = this.state.countriesConversion.find(e => e.iso3 === iso3);

        if (obj !== undefined) {
            res = obj.iso2;
        }
        return res;
    };


    getRow = (item, index) => {
        //let flag = environment.getServerBasePath() + '/dashboard/download?providerID=' + item.id;

        return (

            <React.Fragment key={index}>

                <tr key={index}>
                    <td>{item.numOfLines}</td>
                    <td>{item.numOfCustomers}</td>
                    <td>{item.name}</td>
                    {/*<td><img className='dashboard__table-flag' src={flag} alt='flag'/></td>*/}

                </tr>

            </React.Fragment>
        );
    };

    render() {
        let rows = this.props.data.map((item, index) =>
            this.getRow(item, index)
        );

        return (
            <Panel lg={12} xl={8} md={12} title={TextManager.getCurrentTextResource().Text.providers}>
                <Table responsive className='table--bordered dashboard__audience-table'>
                    <thead>
                    <tr>
                        <th>{TextManager.getCurrentTextResource().Text.numOfLines}</th>
                        <th>{TextManager.getCurrentTextResource().Text.numOfCustomers}</th>
                        <th>{TextManager.getCurrentTextResource().Text.name}</th>
                        {/*<th></th>*/}

                    </tr>
                    </thead>
                    <tbody>
                    {rows}
                    </tbody>
                </Table>
            </Panel>
        )
    }
}

